import {
  DEFAULT_BLACK_IMAGE_PATH,
} from '../../../scripts/Routes/images.js';

export const books2020 = [
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Super Pumped',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'The Messy Middle',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Becoming Kareem: Growing Up On and Off the Court',
        'url': '#',
    },
    {
        'src': DEFAULT_BLACK_IMAGE_PATH,
        'text': 'Refactoring: Improving the Design of Existing Code',
        'url': '#',
    },
];
